import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import ReviewGateOverlay from './ReviewGateOverlay';
import GateUnavailableOverlay from './GateUnavailableOverlay';
import { useReviewGateContext } from '../contexts/ReviewGateContext';
import { navigationRef } from '../../App'; // We will export navigationRef from App.tsx

const GlobalReviewGate = () => {
  const {
    isGated,
    reviewCount,
    requiredCount,
    setExempt,
    loading,
    status,
    retry,
    currentSemester,
  } = useReviewGateContext();
  const [currentRoute, setCurrentRoute] = useState<string | undefined>(undefined);
  const [currentRouteParams, setCurrentRouteParams] = useState<any>(undefined);

  useEffect(() => {
    if (!navigationRef.isReady()) return;

    const route = navigationRef.getCurrentRoute();
    setCurrentRoute(route?.name);
    setCurrentRouteParams(route?.params);

    const unsubscribe = navigationRef.addListener('state', () => {
      const current = navigationRef.getCurrentRoute();
      setCurrentRoute(current?.name);
      setCurrentRouteParams(current?.params);
    });

    return unsubscribe;
  }, []);

  const isRecoveryModeRoute =
    (currentRoute === 'Courses' && currentRouteParams?.recoveryMode === true) ||
    (currentRouteParams?.screen === 'Courses' && currentRouteParams?.params?.recoveryMode === true);

  const handleGoToRecovery = () => {
    if (navigationRef.isReady()) {
      // @ts-ignore
      navigationRef.navigate('TabRoot', {
        screen: 'Courses',
        params: {
          recoveryMode: true,
          recoveryType: 'review',
          recoveryOrigin: 'unavailable',
          lockedAcademicYear: currentSemester.academicYear,
          lockedSemester: currentSemester.semester,
        },
      });
    }
  };

  // ゲートを表示しない画面のリスト
  const exemptRoutes = [
    'Schedule', // 時間割画面
    'CourseReviewForm', // レビュー投稿画面自体
    'GradeSubmit', // 成績入力画面
    'ReviewManagement', // レビュー管理画面
    'Settings', // 設定画面
    'CalendarExport', // Read-only export of the already-accessible personal timetable.
  ];

  if (currentRoute && exemptRoutes.includes(currentRoute)) {
    return null;
  }

  if (isRecoveryModeRoute) return null;

  // タブ画面の判定
  const tabRoutes = ['Courses', 'SavedSchedules'];
  const isTabRoute = currentRoute && tabRoutes.includes(currentRoute);

  // タブバーが表示されている画面では、タブバーの上までを覆うようにする
  // iOS: bottom margin 20 + bottom 25 + height 80 = 125
  // Android/Web: height 60
  const bottomOffset = isTabRoute ? (Platform.OS === 'ios' ? 125 : 60) : 0;

  if (status !== 'ready' && isGated) {
    return (
      <GateUnavailableOverlay
        visible={true}
        loading={status === 'loading'}
        onRetry={() => { void retry(); }}
        onGoToRecovery={handleGoToRecovery}
        bottomOffset={bottomOffset}
      />
    );
  }

  if (!isGated) return null;

  const handleGoToReview = () => {
    if (navigationRef.isReady()) {
      // @ts-ignore
      navigationRef.navigate('ReviewManagement');
    }
  };

  const handleGoToGatedRecovery = () => {
    if (navigationRef.isReady()) {
      // @ts-ignore
      navigationRef.navigate('TabRoot', {
        screen: 'Courses',
        params: {
          recoveryMode: true,
          recoveryType: 'review',
          lockedAcademicYear: currentSemester.academicYear,
          lockedSemester: currentSemester.semester,
        },
      });
    }
  };

  return (
    <ReviewGateOverlay
      visible={true}
      reviewCount={reviewCount}
      requiredCount={requiredCount}
      onGoToReview={handleGoToReview}
      onGoToRecovery={handleGoToGatedRecovery}
      onExempt={setExempt}
      loading={loading}
      bottomOffset={bottomOffset}
    />
  );
};

export default GlobalReviewGate;
